import { useCallback } from 'react';
import { useEditor } from '@craftjs/core';
import { isPercentage } from '../utils/numToMeasurement'; 

const WIDTH_PROP_KEY = 'width'; 
const HEIGHT_PROP_KEY = 'height';
const MAX_RECIPE_WIDTH_PX = 794;

export const usePropagateDimensions = () => {
    const { actions, query } = useEditor();

    const propagateDimensionToAuto = useCallback((nodeId, dimensionKey, maxLimit) => {
        if (!nodeId) return;

        const node = query.node(nodeId).get();
        if (!node) return;
        
        const parentId = node.data.parent;
        const currentDimension = node.data.props[dimensionKey];

        if (dimensionKey === WIDTH_PROP_KEY && isPercentage(currentDimension)) {
            return;
        }

        if (currentDimension && currentDimension !== 'auto') {
            
            const isRootNode = query.node(nodeId).isRoot();
            
            if (dimensionKey === WIDTH_PROP_KEY && isRootNode) {
                return; 
            }
            
            actions.setProp(nodeId, (prop) => {
                prop[dimensionKey] = 'auto';
            }, 500); 
        }
        
        if (parentId) {
            propagateDimensionToAuto(parentId, dimensionKey, maxLimit);
        }
    }, [actions, query]);
    
    const propagateHeight = useCallback((nodeId) => {
        propagateDimensionToAuto(nodeId, HEIGHT_PROP_KEY, null);
    }, [propagateDimensionToAuto]);
    
    const propagateWidth = useCallback((nodeId) => {
        propagateDimensionToAuto(nodeId, WIDTH_PROP_KEY, MAX_RECIPE_WIDTH_PX);
    }, [propagateDimensionToAuto]);

    return { propagateHeight, propagateWidth, MAX_RECIPE_WIDTH_PX };
};
